import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vehicle-and-location"
}
const _hoisted_2 = {
  key: 0,
  class: "date"
}
const _hoisted_3 = { class: "sub-head" }
const _hoisted_4 = { "data-testid": "test-drive-dayAndTimeLabel" }
const _hoisted_5 = {
  key: 1,
  class: "location"
}
const _hoisted_6 = {
  class: "sub-head",
  "data-testid": "test-drive-locationLabel"
}
const _hoisted_7 = { class: "location-address" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "vehicle"
}
const _hoisted_10 = {
  class: "sub-head",
  "data-testid": "test-drive-vehicleLabel"
}

import { useDisplay } from 'vuetify';
import ScheduleTestDriveVehicleInfo from '@components/Page/ScheduleTestDrive/ScheduleTestDrive--VehicleInfo.vue';
import { formatDealerId } from '@/util/scheduleTestDriveUtil';

import { defineComponent, PropType } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useScheduleTestDriveStore } from '@/stores/scheduleTestDrive';
import { FieldsPropType } from '@/lib/FieldTypes';

const __default__ = defineComponent({
  name: 'ScheduleTestDrive--VehicleAndLocation',
  components: {},
  computed: {
    ...mapState(useScheduleTestDriveStore, ['day', 'time', 'view', 'vehicle', 'dealership']),
  },
  props: {
    fields: {
      type: Object as PropType<FieldsPropType>,
      default: () => ({}),
    },
    rendering: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    errorComponent: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dateAndTimeLabel: 'Date & time',
      editLabel: 'Edit',
      location: {},
      hideDetailsLabel: 'Hide details',
      locationLabel: 'Location',
      showDetails: false,
      showDetailsLabel: 'Show details',
      vehicleLabel: 'Car',
    };
  },
  methods: {
    ...mapActions(useScheduleTestDriveStore, ['setTestDriveView']),
    editDayAndTime() {
      this.showDetails = false;
      this.setTestDriveView('dayAndTime');
    },
    getLocaleDay(day: string) {
      const normalizedDay = day.replaceAll('-', '/');
      const date = new Date(`${normalizedDay} GMT-12:00`); // we don't want timezone to be a factor in the simple date conversion
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: undefined,
        month: 'long',
        day: 'numeric',
      });
    },
    toggleShowDetails() {
      this.showDetails = !this.showDetails;
    },
  },
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { mdAndDown, lgAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.view !== 'confirmation')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.day && _ctx.time && _ctx.view === 'contactInfo')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_component_v_icon, { icon: "ep-icon-calendar" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.fields.dateAndTimeLabel.value), 1)
                ]),
                _createElementVNode("span", {
                  class: "edit-link",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editDayAndTime && _ctx.editDayAndTime(...args))),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.editDayAndTime && _ctx.editDayAndTime(...args)), ["enter"])),
                  "data-testid": "test-drive-editLabel"
                }, [
                  _createVNode(_component_v_icon, { icon: "ep-icon-edit" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.editLabel), 1)
                ], 32)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.getLocaleDay(_ctx.day)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.time), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(lgAndUp) || _ctx.view === 'dayAndTime' || (_ctx.view === 'contactInfo' && _ctx.showDetails))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _createVNode(_component_v_icon, { icon: "ep-icon-location-building" }),
                _createTextVNode(" " + _toDisplayString(_ctx.fields.locationLabel.value), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(_unref(formatDealerId)(_ctx.dealership?.dealerId ?? '')) + " (" + _toDisplayString(_ctx.vehicle?.distanceToUser) + " mi)", 1),
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.dealership.address), 1),
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.dealership.city) + ", " + _toDisplayString(_ctx.dealership.state) + " " + _toDisplayString(_ctx.dealership.zip), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(lgAndUp) || _ctx.view === 'dayAndTime' || (_ctx.view === 'contactInfo' && _ctx.showDetails))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, [
                _createVNode(_component_v_icon, { icon: "ep-icon-car" }),
                _createTextVNode(" " + _toDisplayString(_ctx.fields.vehicleLabel.value), 1)
              ]),
              _createVNode(ScheduleTestDriveVehicleInfo)
            ]))
          : _createCommentVNode("", true),
        (_unref(mdAndDown) && _ctx.view === 'contactInfo')
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "show-details",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleShowDetails && _ctx.toggleShowDetails(...args))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggleShowDetails && _ctx.toggleShowDetails(...args)), ["enter"]))
            }, [
              _createElementVNode("span", null, [
                (_ctx.showDetails)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.fields.hideDetailsLabel.value) + " ", 1),
                      _createVNode(_component_v_icon, { icon: "ep-icon-chevron-up" })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.fields.showDetailsLabel.value) + " ", 1),
                      _createVNode(_component_v_icon, { icon: "ep-icon-chevron-down" })
                    ], 64))
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})